import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  makeStyles,
  IconButton,
  Tooltip,
  Button,
  Grid,
  Typography,
  DialogTitle,
  Divider,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";
import { useDispatch, useSelector } from "react-redux";
import { createUser, getUsers, getRoles, getLocations} from "../../../actions/usersAction";
import Feedback from "../../../utils/Feedback";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  title: {
    fontSize: 13,
  },
  time: {
    // marginLeft: "auto",
    marginTop: 10,

    // width: 120,
    width: "fit-content",
    height: 40,
    padding: theme.spacing(1),
    // textAlign: "center",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    marginRight: 5,
  },
  btn: {
    padding: theme.spacing(1.5),
    marginTop: 30,
    marginBottom: 30,
    width: 300,
    [theme.breakpoints.down("sm")]: {
      width: "50%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    }
  },

  dialog: {
    [theme.breakpoints.down("sm")]: {
      margin: 0,
      width: "100%",
    },
  },
  
  formControl: {
    minWidth: 420,
    [theme.breakpoints.down("sm")]: {
      minWidth: 350,
    },
    [theme.breakpoints.down("xs")]: {
        minWidth: "100%",
    },
},

}));

const INIT_STATE = {
  firstname: "",
  lastname: "",
  email: "",
  title: "",
  role: [],
  location: undefined,
  phone: "",
};

const CreateUserModal = ({ openCreate, handleCloseCreate }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [state, setState] = useState(INIT_STATE);
  const [feed, setFeed] = React.useState({
    loading: false,
    open: false,
    message: "",
    success: false,
  });

  const { error, loading, roles, locations } = useSelector((state) => state.users);

  useEffect(() => {
    dispatch(getRoles());
    dispatch(getLocations());
  }, [dispatch]);


  useEffect(() => {
    const abortController = new AbortController();
    if (error && error !== null) {
      setFeed((prev) => ({
        loading: false,
        open: true,
        message: error,
        success: false,
      }));
    }
    return () => {
      abortController.abort();
    };
  }, [error]);

  const handleChange = (e) => {
    e.persist();
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let data = {
      firstname: state.firstname,
      lastname: state.lastname,
      email: state.email,
      title: state.title,
      role: state.role,
      location: state.location,
      phone: state.phone,
      path: "setPassword"
    };

    try {
      await dispatch(createUser(data));
      handleCloseCreate();
      dispatch(getUsers());
      setState(INIT_STATE);
      setFeed((prev) => ({
        loading: false,
        open: true,
        message: "User Created Successfully.",
        success: true,
      }));
    } catch (err) {
      setFeed((prev) => ({
        ...prev,
        loading: false,
        open: true,
        message: err.message || "Failed to create user.",
        success: false,
      }));
    }
  };

  const handleCloseFeed = () => {
    setFeed((prevState) => ({ ...prevState, open: false }));
  };

  const isValid = () =>
    !state.firstname || !state.lastname || !state.role || !state.email || !state.title ;

  return (
    <div>
      {feed.success ? (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="success"
          message={feed.message}
        />
      ) : (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="error"
          message={feed.message}
        />
      )}
      <Dialog
        open={openCreate}
        onClose={handleCloseCreate}
        fullWidth
        maxWidth="md"
        className={classes.dialog}

      >
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="overline" className={classes.title}>
                Create User
              </Typography>
            </Grid>
            <Grid item>
              <Tooltip arrow title="Close">
                <IconButton onClick={handleCloseCreate}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </DialogTitle>
        <Divider />
        <DialogContent className={classes.dialogContent}>
          <form onSubmit={handleSubmit} className={classes.form}>
            <Grid container justifyContent="center" alignItems="center" spacing={3}>
            <Grid item xs={12} sm={6}>
                <TextField
                  name="firstname"
                  fullWidth
                  variant="outlined"
                  label="First Name"
                  onChange={handleChange}
                  value={state.firstname}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="lastname"
                  fullWidth
                  variant="outlined"
                  label="Last Name"
                  onChange={handleChange}
                  value={state.lastname}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="email"
                  fullWidth
                  variant="outlined"
                  label="Email"
                  onChange={handleChange}
                  value={state.email}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="title"
                  fullWidth
                  variant="outlined"
                  label="Title"
                  onChange={handleChange}
                  value={state.title}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="phone"
                  fullWidth
                  variant="outlined"
                  label="Phone"
                  onChange={handleChange}
                  value={state.phone}
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">
                 Primary Location
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  fullWidth
                  value={state.location || ""}
                  name="location"
                  onChange={handleChange}
                  label="Location"
                >
                  <MenuItem value={null}>
                    <em>None</em>
                  </MenuItem>
                  {locations &&
                    locations.map((location) => (
                      <MenuItem key={location._id} value={location._id}>
                        {location.displayname}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              </Grid>
              
              <Grid item xs={12} sm={12}>
                <FormControl variant="outlined" className={classes.formControl}>
                    <Autocomplete 
                        multiple
                        id="role"
                        options={roles}
                        getOptionSelected={(option, value) => option._id === value._id}
                        getOptionLabel={(option) => option.displayname} 
                        onChange={(e, value) => setState((prevState) => ({ ...prevState, role: value }))} 
                        renderInput={(params) => 
                        <TextField {...params} variant="outlined" label="Roles" />} 
                    />
                </FormControl>
              </Grid>

            </Grid>
            <Typography align="center">
              <Button
                color="primary"
                variant="contained"
                fullWidth
                size="large"
                type="submit"
                className={classes.btn}
                disabled={isValid() || loading}
              >
                {loading ? "Loading..." : "Save"}
              </Button>
            </Typography>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CreateUserModal;
